// src/data.js
export default [
  {
    imageUrl: require('./assets/Architecture/ProffersorHesabi/1-2-min.jpg'),
    caption: 'آرامگاه پروفسور حسابی',
    secondaryCaption: 'Hesaby monument',
    exam: true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/ProffersorHesabi/2-min.jpg'),
        description: 'آرامگاه پروفسور حسابی'
      },
      {
        imageUrl: require('./assets/Architecture/ProffersorHesabi/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/ProffersorHesabi/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/ProffersorHesabi/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/ProffersorHesabi/6-min.jpg'),
        description: null
      }
    ]
  },
  {
    imageUrl: require('./assets/Architecture/KasinComplex/1-2-min.jpg'),
    caption: 'مجتمع آب درمانی کاسین',
    secondaryCaption: 'Kasin hydrotherapy complex',
    vid:true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/KasinComplex/2-min.jpg'),
        description: 'مجتمع آب درمانی کاسین'
      },
      {
        vidUrl: require('./assets/Architecture/KasinComplex/1-3.mp4'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/KasinComplex/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/KasinComplex/4-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/HotelBotique/1-2-min.jpg'),
    caption: 'هتل بوتیک خیابان فردوسی تبریز',
    secondaryCaption: 'Botique Hotel',
    vid:true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/HotelBotique/3-min.jpg'),
        description: 'هتل بوتیک خیابان فردوسی تبریز'
      },
      {
        imageUrl: null,
        vidUrl: require('./assets/Architecture/HotelBotique/1-3.mp4'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/HotelBotique/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/HotelBotique/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/HotelBotique/6-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/HotelBotique/7-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/HotelBotique/8-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/Khavaran1/1-2-min.jpg'),
    caption: 'ساختمان های 15 طبقه شهرک خاوران تبریز',
    secondaryCaption: '15-stiry building in khavaran town',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/Khavaran1/1-min.jpg'),
        description: 'ساختمان های 15 طبقه شهرک خاوران تبریز'
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/Khavaran1/2-2-min.jpg'),
    caption: 'مجتمع های ویلایی شهرک خاوران تبریز',
    secondaryCaption: 'Villa complex in khavaran town of tabriz',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/Khavaran1/3-min.jpg'),
        description: 'مجتمع های ویلایی شهرک خاوران تبریز'
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/EngelabMeydan/1-2-min.jpg'),
    caption: 'میدان انقلاب تهران',
    secondaryCaption: 'Designing the engelab square',
    exam: true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/EngelabMeydan/2-min.jpg'),
        description: 'میدان انقلاب تهران'
      },
      {
        imageUrl: require('./assets/Architecture/EngelabMeydan/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/EngelabMeydan/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/EngelabMeydan/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/EngelabMeydan/6-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/HotelKhavaran/1-2-min.jpg'),
    caption: 'هتل 5 ستاره خاوران',
    secondaryCaption: 'Five star hotel in khavaran',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/HotelKhavaran/2-min.jpg'),
        description: 'هتل 5 ستاره خاوران'
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/CommercialComplex/1-2-min.jpg'),
    caption: 'مجتمع تجاری ارتش',
    secondaryCaption: 'Commercial Complex',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/CommercialComplex/2-min.jpg'),
        description: 'مجتمع تجاری ارتش'
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/BaghYaghoob/1-2-min.jpg'),
    caption: 'ویلای باغ یعقوب',
    secondaryCaption: 'Jacob garden villa',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/BaghYaghoob/2-min.jpg'),
        description: 'ویلای باغ یعقوب'
      },
      {
        imageUrl: require('./assets/Architecture/BaghYaghoob/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/BaghYaghoob/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/BaghYaghoob/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/BaghYaghoob/6-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/Shams/1-2-min.jpg'),
    caption: 'آرامگاه شمس تبریزی در خوی',
    secondaryCaption: 'Shams tabrizis mausoleum',
    exam: true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/Shams/2-min.jpg'),
        description: 'آرامگاه شمس تبریزی در خوی'
      },
      {
        imageUrl: require('./assets/Architecture/Shams/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/Shams/4-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Architecture/AzarPark/1-2-min.jpg'),
    caption: 'ساختمان اداری نساجی آذرپارک',
    secondaryCaption: 'Azarpark textile office building',
    secondaryImages: [
      {
        imageUrl: require('./assets/Architecture/AzarPark/2-min.jpg'),
        description: 'ساختمان اداری نساجی آذرپارک'
      },
      {
        imageUrl: require('./assets/Architecture/AzarPark/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/AzarPark/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Architecture/AzarPark/5-min.jpg'),
        description: null
      },
    ]
  },
    {
      imageUrl: require('./assets/Architecture/Elahie/1-2-min.jpg'),
      caption: 'ساختمان الهیه تهران',
      secondaryCaption: 'Elahie building',
      secondaryImages: [
        {
          imageUrl: require('./assets/Architecture/Elahie/2-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/3-min.jpg'),
          description: 'Elahie building'
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/4-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/5-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/6-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/7-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/8-min.jpg'),
          description: null
        },
        {
          imageUrl: require('./assets/Architecture/Elahie/9-min.jpg'),
          description: null
        }
      ]
    },
    {
      imageUrl: require('./assets/Architecture/NemaKhavaran/1-2-min.jpg'),
      caption: 'مجتمع اداری خاوران',
      secondaryCaption: 'Khavaran administrative complex',
      secondaryImages: [
        {
          imageUrl: require('./assets/Architecture/NemaKhavaran/1-min.jpg'),
          description: 'مجتمع اداری خاوران'
        },
      ]
    },
    {
      imageUrl: require('./assets/Architecture/VillaHervy/1-2-min.jpg'),
      caption: 'ویلای هروی',
      secondaryCaption: 'Hervey villa',
      secondaryImages: [
        {
          imageUrl: require('./assets/Architecture/VillaHervy/1-min.jpg'),
          description: 'ویلای هروی'
        },
      ]
    },
  
    
    // Add more data as needed
  ];